import React, { useCallback, useEffect, useState } from 'react';
import { Checkbox } from '@material-ui/core';

import { IHolesPerRound, IMetaFormat } from '../../../../../../store/admin/roundFormats/store';

import { StyledSelectHolesForCTP } from './SelectHolesForCTP.Styles';

interface ISelectHolesForCTPProps {
  metaFormatToUpdate: IMetaFormat;
  setMetaFormatToUpdate: (format: IMetaFormat) => void;
  roundId: number;
}

export const SelectHolesForCTP: React.FunctionComponent<ISelectHolesForCTPProps> = props => {
  const {
    metaFormatToUpdate,
    metaFormatToUpdate: { metadata: holesPerRound },
    setMetaFormatToUpdate,
    roundId
  } = props;

  const [holesList] = useState(new Array(18).fill('empty').map((_, index) => index + 1));

  useEffect(() => {
    if (!metaFormatToUpdate.metadata) {
      setMetaFormatToUpdate({
        ...metaFormatToUpdate,
        metadata: metaFormatToUpdate.rounds.reduce(
          (acc: IHolesPerRound, round) => ({ ...acc, [round]: [] }),
          {}
        )
      });
    }
  }, [metaFormatToUpdate]);

  const setHole = useCallback(
    (selectedHole: number) => (_: any) => {
      if (holesPerRound) {
        const metaFormatHolesPerRound = metaFormatToUpdate.metadata;

        const roundHoles =
          metaFormatHolesPerRound && metaFormatHolesPerRound[roundId]
            ? metaFormatHolesPerRound[roundId]
            : [];

        setMetaFormatToUpdate({
          ...metaFormatToUpdate,
          metadata: {
            ...metaFormatHolesPerRound,
            [roundId]: roundHoles.includes(selectedHole)
              ? roundHoles.filter(hole => hole !== selectedHole)
              : [...roundHoles, selectedHole]
          }
        });
      }
    },
    [metaFormatToUpdate]
  );

  return (
    <StyledSelectHolesForCTP>
      {holesPerRound && metaFormatToUpdate.rounds.includes(roundId) ? (
        <div className="round-holes-selection" key={`round-holes-selection-${roundId}`}>
          <span className="round-label">SELECT THE CLOSEST TO THE PIN HOLES:</span>

          <div className="holes-selector-container">
            {holesList.map(hole => (
              <div className="hole-select-container" key={`hole-select-${roundId}-${hole}`}>
                <Checkbox
                  onClick={setHole(hole)}
                  classes={{ root: 'hole-checkbox' }}
                  checked={holesPerRound[roundId] && holesPerRound[roundId].includes(hole)}
                  color="primary"
                />

                <p className="checkbox-label">{hole}</p>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <></>
      )}
    </StyledSelectHolesForCTP>
  );
};
